import { FC } from 'react';
import { TransactionType } from '@/features/transactions/types/transactions-dto';
import { TransactionsUtils } from '@/features/transactions/utils/transactionsUtils';
import { useTranslation } from 'react-i18next';

type Props = { account: TransactionType };

const TransactionsAccountDetails: FC<Props> = ({ account }) => {
    const { t } = useTranslation();

    const { label, icon: Icon, iconStyles } = TransactionsUtils.getTypeConfig(account);

    return (
        <div className="flex items-center gap-1.5">
            <Icon className={`shrink-0 ${iconStyles}`} />
            <label className={'text-popover-800'}>{t(`${label}`)}</label>
        </div>
    );
};

export default TransactionsAccountDetails;
